import { useNavigate } from 'react-router-dom';
import LegalModal, { ls } from '../components/LegalModal';
import { tokens } from '../tokens';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const close = () => navigate(-1);

  const sections = [
    {
      heading: 'Who We Are',
      content: <p style={ls.body}>GhostLight is operated by NINJA (ninjasgo.com). This policy explains what data we collect, how we use it, and your rights regarding that data.</p>,
    },
    {
      heading: 'What We Collect',
      content: <>
        <h3 style={ls.sub}>Account Information</h3>
        <ul style={ls.list}>
          <li><strong style={ls.strong}>Name</strong> — provided at registration. Never displayed publicly. Accessible only to NINJA administrators.</li>
          <li><strong style={ls.strong}>Email</strong> — used for authentication and password resets. Never displayed publicly.</li>
          <li><strong style={ls.strong}>Department</strong> — used to generate your alias and provide department context on posts.</li>
          <li><strong style={ls.strong}>Alias</strong> — your public pseudonym. Visible to all users.</li>
        </ul>
        <h3 style={ls.sub}>Technical Data</h3>
        <ul style={ls.list}>
          <li>IP address at registration</li>
          <li>Authentication session logs (login timestamps, token metadata)</li>
          <li>Standard web server logs (processed by Nginx)</li>
        </ul>
        <h3 style={ls.sub}>Content You Create</h3>
        <ul style={ls.list}>
          <li>Posts and replies on The Stage</li>
          <li>Debrief responses in The Green Room</li>
          <li>Check-In Pulse responses — aggregated and anonymized for community display</li>
        </ul>
      </>,
    },
    {
      heading: 'What We Do Not Collect',
      content: <ul style={ls.list}>
        <li>We do not track your browsing behavior across other sites</li>
        <li>We do not use analytics cookies or third-party tracking</li>
        <li>We do not collect location data beyond IP at registration</li>
        <li>We do not read Ghost Hours messages — they are end-to-end encrypted</li>
      </ul>,
    },
    {
      heading: 'How We Use Your Data',
      content: <>
        <ul style={ls.list}>
          <li>To provide the GhostLight service (authentication, content display, moderation)</li>
          <li>To send transactional emails (password resets, account notifications)</li>
          <li>To enforce community guidelines through moderation</li>
          <li>To comply with legal obligations</li>
        </ul>
        <p style={{ ...ls.body, marginTop: 14 }}><strong style={ls.strong}>We do not sell your data. We do not use your data for advertising. We do not share your data with third parties except as required by law.</strong></p>
      </>,
    },
    {
      heading: 'Who Can Access Your Identity',
      content: <table style={{ width: '100%', fontSize: 14, borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: `1px solid ${tokens.edge}` }}>
            <th style={{ textAlign: 'left', padding: '10px 0', color: tokens.textLow, fontFamily: tokens.fontBody, fontWeight: 400, fontSize: 13 }}>Role</th>
            <th style={{ textAlign: 'left', padding: '10px 0', color: tokens.textLow, fontFamily: tokens.fontBody, fontWeight: 400, fontSize: 13 }}>Can See</th>
          </tr>
        </thead>
        <tbody style={{ color: tokens.textMid, fontFamily: tokens.fontBody, fontSize: 14 }}>
          <tr style={{ borderBottom: `1px solid ${tokens.edge}` }}>
            <td style={{ padding: '12px 0' }}>Other users</td>
            <td style={{ padding: '12px 0' }}>Your alias and department only</td>
          </tr>
          <tr style={{ borderBottom: `1px solid ${tokens.edge}` }}>
            <td style={{ padding: '12px 0' }}>Moderators</td>
            <td style={{ padding: '12px 0' }}>Your alias only. No access to name or email.</td>
          </tr>
          <tr>
            <td style={{ padding: '12px 0' }}>NINJA administrators</td>
            <td style={{ padding: '12px 0' }}>Name, email, IP, session logs</td>
          </tr>
        </tbody>
      </table>,
    },
    {
      heading: 'Data Retention',
      content: <ul style={ls.list}>
        <li>Account data is retained as long as your account is active</li>
        <li>Upon account deletion: alias, posts, and profile data are purged</li>
        <li>Session logs are retained for a legal compliance window (currently 12 months) and then permanently deleted</li>
        <li>Moderation logs are retained indefinitely for platform safety</li>
      </ul>,
    },
    {
      heading: 'Your Rights',
      content: <>
        <p style={{ ...ls.body, marginBottom: 12 }}>Regardless of your jurisdiction, you have the right to:</p>
        <ul style={ls.list}>
          <li><strong style={ls.strong}>Access</strong> — request a copy of all data we hold about you</li>
          <li><strong style={ls.strong}>Correction</strong> — request correction of inaccurate data</li>
          <li><strong style={ls.strong}>Deletion</strong> — request complete deletion of your account and associated data</li>
          <li><strong style={ls.strong}>Portability</strong> — receive your data in a structured, machine-readable format</li>
        </ul>
        <p style={{ ...ls.body, marginTop: 14 }}>To exercise these rights, contact terrence@ninjasgo.com.</p>
      </>,
    },
    {
      heading: 'Email & Changes',
      content: <>
        <p style={ls.body}>We use Mailjet to send transactional emails (password resets, account notifications). We do not send marketing emails. Your email is shared with Mailjet solely for delivery purposes.</p>
        <p style={{ ...ls.body, marginTop: 14 }}>We may update this policy. Material changes will be communicated on the platform. The "last updated" date reflects the most recent revision.</p>
        <p style={ls.note}>Questions? Contact terrence@ninjasgo.com</p>
      </>,
    },
  ];

  return <LegalModal title="Privacy Policy" updated="Last updated: April 2026" onClose={close} sections={sections} />;
}
